"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPuzzle(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.793.005a3.493 3.493 0 013.487 3.28l.006.212v.704h3.326a2.972 2.972 0 011.803.614l.15.123.143.134c.51.51.816 1.186.865 1.901l.008.196-.002 3.323h.703c.784 0 1.54.264 2.152.742l.163.135.155.147a3.494 3.494 0 01-2.258 5.957l-.212.007h-.704v3.325a2.974 2.974 0 01-.613 1.802l-.124.15-.134.144a2.974 2.974 0 01-1.9.865l-.196.007h-4.857V21.34a1.962 1.962 0 00-3.911-.176l-.012.166v2.443H2.975A2.974 2.974 0 01.012 21l-.007-.196v-4.856h2.433a1.962 1.962 0 00.176-3.91l-.166-.014H.018V7.17a2.965 2.965 0 012.76-2.961l.196-.007H6.3V3.5c0-.785.264-1.542.741-2.152l.136-.163.147-.155A3.493 3.493 0 019.793.005zm0 1.74c-.908 0-1.665.693-1.745 1.597l-.008.154V5.94H2.974c-.628 0-1.149.484-1.21 1.103l-.007.125-.001 3.115h.692c.913 0 1.791.336 2.468.941l.152.144a3.704 3.704 0 01-2.41 6.315l-.209.005h-.702v3.116c0 .634.492 1.163 1.11 1.222l.118.005H6.09v-.703c0-.912.338-1.789.941-2.465l.145-.152a3.704 3.704 0 016.314 2.408l.006.21v.702h3.114c.631 0 1.157-.487 1.22-1.103l.007-.124v-5.065h2.445a1.752 1.752 0 00.153-3.499l-.153-.005h-2.446V7.168c0-.634-.49-1.163-1.108-1.223l-.118-.006h-5.067V3.496a1.75 1.75 0 00-1.75-1.751z"
  }));
}

var _default = SvgPuzzle;
exports["default"] = _default;